import { NumberBox, NumberBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';
import { isRequiredOnceNoteDated } from '../../../../SetupAndBorrower/Setup/functions/isRequiredOnceNoteDated';
import { toPositiveNumber } from './functions/toPositiveNumber';

interface InterestRateFieldProps {
    /** Sub notes take their rate from the master note: it's locked, and labelled by the note's interest type. */
    isSubNote?: boolean;
}

export const InterestRateField = ({ isSubNote = false }: InterestRateFieldProps) => {
    const value = useStandardLoanStore((state) => state.loan.interestRate);
    const setup = useStandardLoanStore((state) => state.setup);
    const interestTypeId = useStandardLoanStore((state) => state.loanStepContext.interestTypeId);
    const updateLoan = useStandardLoanStore((state) => state.updateLoan);

    return (
        <NumberBox
            id='loanInterestRate'
            value={value}
            onChange={(rate) => updateLoan({ interestRate: toPositiveNumber(rate) })}
            label={isSubNote && interestTypeId !== 0 ? 'Sprd over Prime' : 'Interest Rate'}
            required={isRequiredOnceNoteDated(setup)}
            disabled={isSubNote}
            format="#0.##'%'"
            width='100%'
            height='36px'
            layoutStyle={NumberBoxLayoutStyle.Horizontal}
            labelWidth='150px'
        />
    );
};
